// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"EditableTextArea_Wrapper__20HlO","TextArea":"EditableTextArea_TextArea__cZ6Gj","Pincode":"EditableTextArea_Pincode__uHDzC"};